export const languageConstants = {
  SET_LANGUAGE_CONFIG: 'SET_LANGUAGE_CONFIG'
};
